import { render, staticRenderFns } from "./JobNotesView.vue?vue&type=template&id=b059a3d2&"
import script from "./JobNotesView.vue?vue&type=script&lang=js&"
export * from "./JobNotesView.vue?vue&type=script&lang=js&"
import style0 from "./JobNotesView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports